export default "__VITE_ASSET__DIdqz8UZ__"